import { render } from "./leads-details.vue?vue&type=template&id=b15c1748&scoped=true"
import script from "./leads-details.vue?vue&type=script&lang=js"
export * from "./leads-details.vue?vue&type=script&lang=js"

import "./leads-details.vue?vue&type=style&index=0&id=b15c1748&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b15c1748"]])

export default __exports__